import React from 'react';
import { Linkedin } from 'lucide-react';
import { teamMembers } from '../../data/mock';

const TeamSection = () => {
  return (
    <section id="team" className="py-16 sm:py-20 bg-[var(--bg-page)]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-12">
          <h2 className="heading-1 mb-4">Our Team</h2>
          <p className="body-large max-w-2xl mx-auto">
            The experienced professionals behind SuperHunt, combining decades of 
            recruitment expertise with cutting-edge technology.
          </p>
        </div>

        {/* Team Grid - Circular Photos */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-8">
          {teamMembers.map((member) => (
            <a
              key={member.id}
              href={member.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="group block text-center"
            >
              {/* Circular Photo with Frame */}
              <div className="relative mx-auto mb-4 w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32">
                {/* Outer Ring */}
                <div className="absolute inset-0 rounded-full border-2 border-[var(--brand-teal-200)] group-hover:border-[var(--brand-teal-400)] transition-colors" />
                {/* Inner Photo Container */}
                <div className="absolute inset-1 rounded-full overflow-hidden bg-gradient-to-br from-[var(--brand-teal-500)] to-[var(--brand-teal-600)] group-hover:scale-105 transition-transform duration-300">
                  {member.image ? (
                    <img
                      src={member.image}
                      alt={member.name}
                      className={`w-full h-full object-cover object-top ${member.grayscale ? 'grayscale' : ''}`}
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center">
                      <span className="text-2xl sm:text-3xl font-bold text-white/80">
                        {member.name.split(' ').map(n => n[0]).join('')}
                      </span>
                    </div>
                  )}
                </div>
                {/* LinkedIn Badge */}
                <div className="absolute -bottom-1 -right-1 w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-white shadow-md flex items-center justify-center group-hover:bg-[var(--brand-teal-50)] transition-colors">
                  <Linkedin className="w-4 h-4 text-[var(--brand-teal-600)]" />
                </div>
              </div>
              
              {/* Info */}
              <h3 className="font-semibold text-sm sm:text-base text-[var(--text-primary)] group-hover:text-[var(--brand-teal-700)] transition-colors">
                {member.name}
              </h3>
              <p className="text-xs sm:text-sm text-[var(--text-muted)]">{member.role}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
